module.exports = __webpack_public_path__ + "static/img/products_cooler_mobile.8ddd2bf7.jpg";